import { gql } from '../utils/general';

export const deleteSubjectStoryClaims = gql`
  mutation deleteClaims($subjectIds: [uuid!], $storyIds: [String!]) {
    delete_subjectStoryClaims(where: {subjectId: {_in: $subjectIds}, storyId: {_in: $storyIds}}) {
      affected_rows
    }
  }
`;

export const getSubjectPublicationClaimsByPublicationId = gql`
  query getSubjectPublicationClaimsByPublicationId($publicationId: uuid!) {
    subjectPublicationClaims(where: { publicationId: { _eq: $publicationId } }) {
      subjectId
      subjectType
      publicationClaim
      sectionIds
    }
  }
`;

export const getSubjectStoryClaimsByStoryIds = gql`
  query getSubjectStoryClaimsByStoryIds($storyIds: [String!]!) {
    subjectStoryClaims(where: { storyId: { _in: $storyIds } }) {
      subjectId
      subjectType
      storyId
      storyClaims
    }
  }
`;

export const insertSubjectPublicationClaims = gql`
  mutation insertSubjectPublicationClaims($subjectPublicationClaimsList: [subjectPublicationClaims_insert_input!]!) {
    insert_subjectPublicationClaims(objects: $subjectPublicationClaimsList) {
      affected_rows
    }
  }
`;

export const insertSubjectStoryClaims = gql`
  mutation insertSubjectStoryClaims($subjectStoryClaimsList: [subjectStoryClaims_insert_input!]!) {
    insert_subjectStoryClaims(objects: $subjectStoryClaimsList) {
      affected_rows
    }
  }
`;
